import FullWidthButton from './FullWidthButton';

export default FullWidthButton;
